module.exports = __webpack_public_path__ + "static/media/bfile-life-stage-2.13c6220e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bfile-life-stage-2.png
// module id = 2666
// module chunks = 0